export default __webpack_public_path__ + "static/media/job-switching-arrow-left.0daea3ec.svg";